module.exports = __webpack_public_path__ + "static/media/trophy.f9ea001a.svg";